import React from 'react';
import { Box, Button, HStack, Text, Center } from '@chakra-ui/react';
import { RiDragMove2Line } from 'react-icons/ri';
import { FaMinus, FaPlus } from "react-icons/fa";
import '../styles/trialtoast.css';
import Draggable from 'react-draggable';

const TrialToastContent = ({ isCollapsed, setIsCollapsed, colorMode, navigate, toastMessage }) => (
    <Draggable handle=".drag-handle">
        <Box
            pt={1}
            pb={2}
            px={3}
            bg={colorMode === 'light' ? "blue.500" : "blue.200"}
            borderRadius="md"
            zIndex={9999}
            minW="300px"
            position="relative" // So absolute positioning works inside
            minH="27px"
        >
            {/* Drag icon top-left */}
            <Box
            className="drag-handle"
            cursor="grab"
            position="absolute"
            top="4px"
            left="5px"
            display="flex"
            alignItems="center"
            >
            <Box as={RiDragMove2Line} w="18px" h="18px" color={colorMode === "light" ? "white" : "black"} />
            </Box>

            {/* Collapse button top-right */}
            <Box
            position="absolute"
            top="4px"
            right="8px"
            display="flex"
            alignItems="center"
            >
            <button
                onClick={() => setIsCollapsed(!isCollapsed)}
                style={{
                color: "white",
                fontSize: "16px",
                background: "none",
                border: "none",
                cursor: "pointer",
                padding: "0px",
                lineHeight: "1",
                }}
            >
                {isCollapsed ? <FaPlus color={colorMode === "light" ? "white" : "black"}/> : <FaMinus color={colorMode === "light" ? "white" : "black"}/>}
            </button>
            </Box>

            {/* Trial message content */}
            {!isCollapsed && (
            <Box mt="20px">
                <HStack spacing={4} align="center">
                <Box>
                    <Text
                        className={colorMode === 'light' ? 'toastmessage' : 'toastmessage toastmessage-dark'}
                        mb={0}
                        lineHeight="1.2"
                        >
                        {toastMessage?.message}
                    </Text>
                    <Center>
                    <Text
                        className={colorMode === 'light' ? 'toastmessageexpiry' : 'toastmessageexpiry toastmessageexpiry-dark'}
                        mb={0}
                        >
                        Expires on {toastMessage?.expiry}
                    </Text>
                    </Center>
                </Box>
                <Button
                    colorScheme={colorMode === 'light' ? "whiteAlpha" : "blackAlpha"}
                    size="sm"
                    onClick={() => navigate("/payment")}
                >
                    Upgrade Now
                </Button>
                </HStack>
            </Box>
            )}
        </Box>
    </Draggable>
);

export default TrialToastContent;